import { Byte } from "@angular/compiler/src/util";
import { SizeDirective } from "@ks89/angular-modal-gallery/lib/directives/size.directive";



export class CategoryDTO {
     description: string;
     fr_description:string;
     es_description:string;
     category: string;
     category_title:string;
     es_category_title:string;
     fr_category_title:string;
     detail:string;
     es_detail:string;
     fr_detail:string;
     idcategory: number;
     categoryimages: CategoryImageDTO;
}
export class CategoryImageDTO {
     // idimage: number;
     name: string;
     blobValue:string;
     categoryId:number;

}

export class SubCategoryDTO {
     idsubcategory: number;
     description: string;
     CategoryIdcategory: number;
     CategoryIdcategoryNavigation: CategoryDTO;
}

export class BrandDTO {
     idbrand: number;
     brand1: string;
     es_brand:string;
     fr_brand:string;
}
export class CollectionDTO {
     idcollection: number;
     description: string;
}
export class TagDTO {
     idtag: number;
     tag1: string;
}
export class ProductsDTO{
     Title: string;
     Fr_Title:string;
     Es_Title:string;
     CodeProduct: string;
     Sale: boolean;
     Idproduct: number;
     Description:string;
     Es_Description:string;
     Fr_Description:string;
     CollectionIdcollection: number;
     SubCategoryIdsubcategory?: number;
     BrandIdbrand: number;
     CategoryIdcategory: number;
     Tag: string;
     BrandIdbrandNavigation: BrandDTO;
     CategoryIdcategoryNavigation: CategoryDTO;
     CollectionIdcollectionNavigation: CollectionDTO;
     SubCategoryIdsubcategoryNavigation?: SubCategoryDTO;
     ImageDTOs:Image1DTO[];
     IsProductHasColor:boolean
}

export class VariantDTO{
     Sku: string;
     Id: number;
     Size: number;
     Color: number;
     Idvariant: number;
     Price: number;
     Descriptionvariant: string;
     Fr_Descriptionvariant: string;
     Es_Descriptionvariant: string;
     New: boolean;
     ColorIdColor?: number;
     StockIdstock: number;
     SizeIdSize?: number;
     CodeProduct: string;
     Status: boolean;
     Quantity: number;
     CodeProductNavigation: ProductsDTO;
     SizeIdSizeNavigation: SizeDTO;
     ColorIdColorNavigation: ColorDTO;
}

export class SizeDTO{
     idSize: number;
     size1: string;
}

export class StockDTO {
     qte?: number;
     idstock: number;
}


export class ImageDTO{
     src: Blob;
     alt: string;
     idimage: number;
     productsIdproduct: number;
     variantIdvariant: number;
}

export class ProductImgDTO{
     location: string;
     name: string;
     idproduct: number;
     idimage: number;
}

export class Image1DTO{
  blobValue:string;
  codeProduct:string;
  name:string;
}

export class ColorDTO {
     idColor: number;
     description: string;
}


export class dropdown {
     value:number;
     title:string;
}



export class OrderDTO{
     OrderId: number;
     CustomerId: number;
     OrderDate: Date;
     Total: number;
     Status: boolean;
     Customer: CustomerDTO;
     Orderitem:OrderItem[];
 }
 
 export class CustomerDTO {
     IsGuest: Boolean | false;
     Email: string | null;
     FirstName: string | null;
     LastName: string | null;
     Phone:string | null;
     Address: string | null;
     City: string | null;
     Country: string | null;
     State: string | null;
     PasswordHash:string | null;
 }

 export class OrderItem {
     OrderItemId: number;
     ProductCode: string;
     Quantity: number;
     UnitPrice: number;
     Size: string;
     Color: string;
     Price: number;
 }
 
 
